/**
 * Canonical Google Sheet column order for the Exposure Report Leads Apps Script.
 * Keep in sync with scripts/ExposureReportLeads/Code.gs
 */
export const LEAD_CAPTURE_COLUMNS = [
    'timestamp',
    'source',
    'type',
    'campaign',
    'conversion_type',
    'asset_name',
    'asset_type',
    'lead_source',
    'report',
    'aiPriority',
    'fullName',
    'email',
    'workEmail',
    'phone',
    'sessionDate',
    'jobTitle',
    'company',
    'concern',
    'systemType',
    'consent',
    'slug',
    'score',
    'verdict',
    'answers',
    'scannedUrl',
    'ipScore',
    'securityScore',
    'exposureRisk',
    'strongSignals',
    'weakSignals',
    'replicable',
    'securityPresent',
    'securityMissing',
    'competitorSummary',
    'actions',
    'reportLink',
    'assignee',
] as const;

export type LeadCaptureColumn = (typeof LEAD_CAPTURE_COLUMNS)[number];

const COLUMN_SET = new Set<string>(LEAD_CAPTURE_COLUMNS);

/** Normalize payload keys and fill every known column (empty string when omitted). */
export function normalizeLeadCapturePayload(
    fields: Record<string, string>,
): Record<string, string>
{
    const merged: Record<string, string> = { ...fields };

    if (!merged.email && merged.workEmail)
    {
        merged.email = merged.workEmail;
    }

    if (!merged.workEmail && merged.email)
    {
        merged.workEmail = merged.email;
    }

    if (!merged.timestamp)
    {
        merged.timestamp = new Date().toISOString();
    }

    if (!merged.source && typeof window !== 'undefined')
    {
        merged.source = window.location.pathname;
    }

    if (!merged.slug && typeof window !== 'undefined')
    {
        merged.slug = window.location.pathname.replace(/^\//, '');
    }

    const row: Record<string, string> = {};

    LEAD_CAPTURE_COLUMNS.forEach((key) =>
    {
        const value = merged[key];
        row[key] = value !== undefined && value !== null ? String(value) : '';
    });

    Object.entries(merged).forEach(([ key, value ]) =>
    {
        if (COLUMN_SET.has(key) || value === undefined || value === null || value === '')
        {
            return;
        }
        row[key] = String(value);
    });

    return row;
}
